import React from 'react';
import { connect } from "react-redux";
import DlUnit from '../../models/DlUnit';
import './DlUnitLi.scss';
import { Form, Button } from 'react-bootstrap';
import { getUnitLi } from "../../actions";


const mapStateToProps = (state) => ({
  uType: state.auth.uType
});

const mapDispatchToProps = (dispatch) => ({
  getUnitLi: (payload) => dispatch(getUnitLi(payload)),
  
});

const DlUnitSearch = ({ getUnitLi, uType }) => {
  let searchInput = React.createRef();

  const hmCh = () => {
    let ch = true;
    return ch;
  }

  const searchCondGet = () => {
    let cond = {};
    let condN = [];
    let searchInputVal = searchInput.current.value;

    condN.push({ slug: { $regex: searchInputVal } });
    if (!isNaN(searchInputVal)) {
      const searchNum = parseInt(searchInputVal);
      condN.push({ num: searchNum });
    }

    for (const [fNam, fNamPar] of Object.entries(DlUnit.fValNams)) {
      condN.push({ ['fVals.' + fNam]: { $regex: searchInputVal } });
    }

    if (hmCh()) {
      cond = {$or: condN};
    } else {
      cond = { $or: condN };
    }

    if (uType == '') {
      cond = {$and: [ { uType: { $ne: 'HM2' } }, cond ]};      
    }

    return cond;

  }

  const searchAct = (ev) => {
    if (typeof ev !== 'undefined') {
      ev.preventDefault();
    }
    const cond = searchCondGet();
    getUnitLi({dlUnitCond: cond});
  }
  
  return (
      <Form style={{ 'marginLeft': '0%' }} onSubmit={searchAct}>
          <Form.Group controlId="formBasicSearch">
          <Form.Label>Pretraživanje</Form.Label>
          <Form.Control type="text" ref={searchInput} placeholder="ključna reč" />
          </Form.Group>
          <Button variant="primary" type="button" onClick={ ()=>searchAct() }>
          OK
          </Button>
      </Form>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitSearch);
